import * as tslib_1 from "tslib";
var POLL_INTERVAL_MS = 100;
/**
 * Resolves the LFX analytics instance once its CDN script has run, or `null` if it has not run
 * within `timeoutMs` (blocked, failed to load, or not configured).
 *
 * The script tag is `async` and the CDN revalidates it on every page load, so on repeat visits
 * Angular usually renders before `window.LfxAnalytics` exists. Checking once at render time
 * silently skips the analytics call; wait for it instead.
 */
export function whenLfxAnalyticsReady(timeoutMs) {
    if (timeoutMs === void 0) { timeoutMs = 10000; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var deadline, analytics;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    deadline = Date.now() + timeoutMs;
                    _a.label = 1;
                case 1:
                    if (!!(window.LfxAnalytics && window.LfxAnalytics.LfxSegmentsAnalytics)) return [3 /*break*/, 3];
                    if (Date.now() >= deadline) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, POLL_INTERVAL_MS); })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 1];
                case 3:
                    analytics = window.LfxAnalytics.LfxSegmentsAnalytics.getInstance();
                    // The script tag's onload has normally started it already; init() reuses that run.
                    return [4 /*yield*/, analytics.init()];
                case 4:
                    // The script tag's onload has normally started it already; init() reuses that run.
                    _a.sent();
                    return [2 /*return*/, analytics];
            }
        });
    });
}
